import React, { useState, useContext } from 'react'
import { ThemeContext } from "../../Context/ThemeContext.js";
import './Dashboard.css'
import data from '../../data.json'
import Grid from '../../images/Grid.png'
import List from '../../images/List.png'
import Modal from '../Modal/Modal.jsx';

const Dashboard = () => {

    const theme = useContext(ThemeContext);
    const darkMode = theme.state.darkMode;
    const [searchterm, setSearchterm] = useState('')
    const coins = data;


    // 👇️ sort by Numeric property ASCENDING (1 - 100)
    const numAscending = [...coins].sort((a, b) => a.Price - b.Price);

    // 👇️ sort by Numeric property DESCENDING (100 - 1)
    const numDescending = [...coins].sort((a, b) => b.Price - a.Price);

    const [value, setValue] = useState(coins)

    const handleChange = (event) => {
        // setValue(event.target.value);
        if (event.target.value === 'assending') {
            setValue(numAscending)
        } else if (event.target.value === 'descending') {
            setValue(numDescending)
        } else {
            setValue(coins)
        }
    }

    const [modal, setModal] = useState(false)
    const [cname, setCname] = useState('default')
    const [icon, setIcon] = useState('default')
    const [avbal, setAvbal] = useState('0.000')
    const [mystakes, setMystakes] = useState('0%')
    const [earnings, setEarnings] = useState('0.000')

    function showmodal(cname, icon, mystakes, earnings) {
        setCname(cname)
        setIcon(icon)
        setMystakes(mystakes)
        setAvbal('0.000')        // should be loaded from api directly
        setEarnings(earnings)
        setModal(!modal)
    }

    return (
        <div className='dashboard'>
            <Modal trigger={modal} showmodal={showmodal} cname={cname} icon={icon} avbal={avbal} mystakes={mystakes} earnings={earnings} />
            <div className="search">
                <div className="search-input">
                    <div className="search-grp1">
                        <label htmlFor='sort' className="search-label">
                            Sort By
                        </label>
                        <div className={`field  ${darkMode ? 'field-dark' : 'field-light'}`}>
                            <select id="sort" name="sort" onChange={handleChange}>
                                <option className='sort-item' value="hat">Hat</option>
                                <option className='sort-item' value='relevent'>Relevent</option>
                                <option className='sort-item' value='assending'>Price from low to high</option>
                                <option className='sort-item' value='descending'>Price from High to low</option>
                                <option className='sort-item' value='popular'>Most Popular</option>
                            </select>
                        </div>
                    </div>
                    <div className="search-grp2">
                        <div className="search-label">
                            Search
                        </div>
                        <div className={`field  ${darkMode ? 'field-dark' : 'field-light'}`}>
                            <div className="input">
                                <input type="text" placeholder='Search' onChange={event => { setSearchterm(event.target.value) }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid-view">
                    <div className={`grid-item ${darkMode ? 'grid-item-dark' : 'grid-item-light'}`}>
                        <img className={`${darkMode ? 'grid-img-dark' : 'grid-img-light'}`} src={Grid} alt="" />
                    </div>
                    <div className={`grid-item ${darkMode ? 'grid-item-dark' : 'grid-item-light'}`}>
                        <img className={`${darkMode ? 'grid-img-dark' : 'grid-img-light'}`} src={List} alt="" />
                    </div>
                </div>
            </div>
            <div className={`title-heading  ${darkMode ? 'title-heading-dark' : 'title-heading-light'}`}>
                <span>Name</span>
                <span>APR</span>
                <span>Liquidity</span>
                <span>My Stakes</span>
                <span>Earnings</span>
            </div>

            {value.filter((val) => {
                if (searchterm === "") {
                    return val;
                } else if (val.Name.toUpperCase().includes(searchterm.toUpperCase())) {
                    return val;
                } else { return false; }
            }).map(({ Name, Icon, APR, Liquidity, MyStakes, Earnings }) => (
                <div className={`row  ${darkMode ? 'row-dark' : 'row-light'}`} key={Name} onClick={() => { showmodal(Name, Icon, MyStakes, Earnings) }}>
                    <div className="name">
                        <img src={Icon} alt="" />
                        <span>{Name}</span>
                    </div>
                    <span>
                        {APR}
                    </span>
                    <span>
                        {Liquidity}
                    </span>
                    <span>
                        {MyStakes}
                    </span>
                    <span>
                        {Earnings}
                    </span>
                </div>
            ))}
        </div>
    )
}

export default Dashboard